import React, { Component } from "react";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import { RenderGridItem } from "@eres/ejari-web/component/Leased/ProjectPropertiesGridView";
import { ProjectPropertyProps } from "@eres/ejari-web/component/Leased/ProjectPropertiesListView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import {
	getProjectPropertyArea,
	getProjectPropertyBuilding,
	getProjectPropertyBuildingCount,
	getProjectPropertyType
} from "@eres/ejari-web/screens/Leased/ProjectProperties";

interface State {
	searchKey?: string;
	page: number;
}

class PropertiesGridView extends Component<ProjectPropertyProps, State> {
	constructor( props: ProjectPropertyProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { properties, onPropertySelect } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: ProjectProperty, index: number ) => {
				return <RenderGridItem
					key={ "project_buildings_grid_" + index }
					property={ item }
					onDetails={ onPropertySelect }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : properties.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { properties } = this.props;
		if ( sKey ) {
			return properties.filter( ( item: ProjectProperty ) => {
				const filterKeys: string[] = [];
				filterKeys.push( getProjectPropertyBuilding( item ) );
				filterKeys.push( getProjectPropertyArea( item ) );
				filterKeys.push( getProjectPropertyBuildingCount( item ) );
				filterKeys.push( getProjectPropertyType( item ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return properties;
	}

	private getPageData( filterData: ProjectProperty[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

export default PropertiesGridView;
